// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ajust-item-norma[data-v-e7bb5b08]:hover{color:#1c8047;background-color:#e7e7e7}", ""]);
// Exports
module.exports = exports;
